import React, { useContext } from 'react'
import moment from 'moment'
import { EPCRContext } from '../EPCR'
import SimpleTextField from '../../../../components/Forms/SimpleTextField'
import { Grid } from '@mui/material'

const PaediatricCO = () => {
  const { formValues, handleChange } = useContext(EPCRContext)

  const isPaediatric =
    (formValues?.demographics?.dobUnknown &&
      formValues?.demographics?.dobUnknownButPaediatric) ||
    moment(formValues?.demographics?.dob).add(18, 'years').isAfter(moment())

  const beingDischarged = [
    'Discharged following Treatment',
    'Discharged - Advice Only',
    'Left before Treatment',
    'Refused Treatment or Transport',
    'A&E - Own Transport',
    'Other',
  ].includes(formValues?.plan?.ptOutcome)

  if (isPaediatric && beingDischarged) {
    return (
      <>
        <Grid item xs={12} lg={8}>
          <SimpleTextField
            value={formValues?.plan?.leftInCareOf}
            onChange={(e) =>
              handleChange({
                moduleName: 'plan',
                field: 'leftInCareOf',
                value: e.target.value,
              })
            }
            label="Left in Care Of"
          />
        </Grid>
      </>
    )
  }
}

export default PaediatricCO
